var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Category"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.900391 4.65977C0.900391 2.29707 0.925689 1.50977 4.05039 1.50977C7.17509 1.50977 7.20039 2.29707 7.20039 4.65977C7.20039 7.02246 7.21036 7.80977 4.05039 7.80977C0.890425 7.80977 0.900391 7.02246 0.900391 4.65977Z",
    stroke: "#FF9800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8008 4.65977C10.8008 2.29707 10.8261 1.50977 13.9508 1.50977C17.0755 1.50977 17.1008 2.29707 17.1008 4.65977C17.1008 7.02246 17.1107 7.80977 13.9508 7.80977C10.7908 7.80977 10.8008 7.02246 10.8008 4.65977Z",
    stroke: "#FF9800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.900391 14.5602C0.900391 12.1975 0.925689 11.4102 4.05039 11.4102C7.17509 11.4102 7.20039 12.1975 7.20039 14.5602C7.20039 16.9228 7.21036 17.7102 4.05039 17.7102C0.890425 17.7102 0.900391 16.9228 0.900391 14.5602Z",
    stroke: "#FF9800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8008 14.5602C10.8008 12.1975 10.8261 11.4102 13.9508 11.4102C17.0755 11.4102 17.1008 12.1975 17.1008 14.5602C17.1008 16.9228 17.1107 17.7102 13.9508 17.7102C10.7908 17.7102 10.8008 16.9228 10.8008 14.5602Z",
    stroke: "#FF9800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.7f9e9581a66a5bb5308506acfbb907ed.svg";
export { ForwardRef as ReactComponent };